import { randomBytes } from 'node:crypto';
import { CloudProvider } from '@wix/backend-as-a-service-client';
import type { BackendAsAServiceClient } from '@wix/backend-as-a-service-client';
import type { DevCenterClient } from '@wix/dev-center-client';

const DEFAULT_ENVIRONMENT_NAME = 'system_global';

export const createAppProjectAndEnvironment = async ({
  appId,
  appName,
  devCenterClient,
  backendAsAServiceClient,
}: {
  appId: string;
  appName: string;
  devCenterClient: DevCenterClient;
  backendAsAServiceClient: BackendAsAServiceClient;
}) => {
  let appProject = await backendAsAServiceClient.getAppProject(appId);
  if (!appProject) {
    const publicKeyAndSecret = await devCenterClient.getAppSecret({ appId });
    appProject = await backendAsAServiceClient.createAppProject({
      id: appId,
      displayName: appName,
      slug: generateRandomSlug(),
      cloudProvider: CloudProvider.CLOUD_FLARE,
      projectType: 'APP',
    });

    return await backendAsAServiceClient.upsertAppEnvironmentVariables(
      appProject.id,
      DEFAULT_ENVIRONMENT_NAME,
      {
        WIX_CLIENT_ID: appId,
        WIX_CLIENT_SECRET: publicKeyAndSecret.appSecret,
        WIX_CLIENT_PUBLIC_KEY: publicKeyAndSecret.webhookPublicKey,
        WIX_CLIENT_INSTANCE_ID: '00000000-0000-0000-0000-000000000000',
      }
    );
  }

  return await backendAsAServiceClient.getAppEnvironmentVariables(
    appProject.id,
    DEFAULT_ENVIRONMENT_NAME
  );
};

function generateRandomSlug() {
  return randomBytes(8).toString('hex');
}
